import type { Saga, SagaChapter } from '@mezha/api'
import { baseApi } from '../baseApi'

/** The novella «Межа» in the journal: chapters opened by rewards. */
export const sagaApi = baseApi.injectEndpoints({
  endpoints: b => ({
    saga: b.query<Saga, void>({ query: () => ({ get: '/api/v1/saga' }), providesTags: ['Saga'] }),
    sagaChapter: b.query<SagaChapter, string>({ query: id => ({ get: `/api/v1/saga/${encodeURIComponent(id)}` }), providesTags: (_r, _e, id) => [{ type: 'Saga', id }] }),
    sagaRead: b.mutation<Saga, { chapter_id: string }>({
      query: body => ({ command: '/api/v1/saga/read', body }),
      onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
        const { data } = await queryFulfilled
        dispatch(sagaApi.util.upsertQueryData('saga', undefined, data))
      },
    }),
  }),
})

export const { useSagaQuery, useSagaChapterQuery, useSagaReadMutation } = sagaApi
